var React = require('react');

function ArrowDownCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-96-270.63 96 96 96-96L374.63 216 256 334.63 137.37 216z"}));
}

ArrowDownCircle.defaultProps = {"stroke":"currentColor","fill":"currentColor","strokeWidth":"0","viewBox":"0 0 512 512","height":"200px","width":"200px"};

module.exports = ArrowDownCircle;

ArrowDownCircle.default = ArrowDownCircle;
